import React, { useEffect, useState } from "react";
import { Container } from "./styles.js";
import Menu from "../../components/Menu/index.jsx";
import { Layout } from "../../Globalstyles/Layout.js";

import { db } from "../../server";
import NoticeBlock from "../../components/NoticeBlock/index.jsx";
import UserBlock from "../../components/UserBlock/index.jsx";
import { IsLoged } from "../../App.js";
import { useNavigate } from "react-router";

export default function Home() {
	const [noticeList, setNoticeList] = useState([]);
	const [userList, setUserList] = useState([]);

	const [loadNotices, setLoadNotices] = useState(true);
	const [loadUsers, setLoadUsers] = useState(true);

	const navigate = useNavigate();

	useEffect(() => {
		if (!IsLoged()) return navigate("/login");
	});

	function loadNoticeList() {
		const dbRef = db.collection("noticias");
		dbRef.get().then((snapshot) => {
			if (!snapshot.empty) {
				const notices = snapshot.docs.slice(0, 10).map((doc) => ({
					id: doc.id,
					...doc.data(),
				}));

				setNoticeList(notices);
				console.log(notices);
			}
		});
	}

	function loadUsersList() {
		const dbRef = db.collection("usuarios");

		dbRef.get().then((snapshot) => {
			if (!snapshot.empty) {
				const users = snapshot.docs.slice(0, 10).map((doc) => ({
					id: doc.id,
					...doc.data(),
				}));

				setUserList(users);
			}
		});
	}

	useEffect(() => {
		if (loadNotices) {
			loadNoticeList();
			setLoadNotices(false);
		}
		if (loadUsers) {
			loadUsersList();
			setLoadUsers(false);
		}
	}, [loadNotices, loadUsers]);

	return (
		<div className="app">
			<Layout className="layout">
				<Menu />
				<Container className="MC">
					<div className="top-content">
						<h1>Dashboard</h1>
					</div>
					<main>
						<div className="noticeViewer wrapper">
							<div>
								<h2>Noticias ativas</h2>

								<ul>
									{noticeList.map((e) => {
										return (
											<li id={e.id}>
												<a href={`/noticeManagement/edit/${e.id}`}>
													<NoticeBlock
														title={e.title}
														shortDesc={e.shortDesc}
													/>
												</a>
											</li>
										);
									})}
								</ul>
							</div>
							<a className="more" href="/noticeManagement">
								Ver todas as noticias
							</a>
						</div>

						<div className="activeUser wrapper">
							<div>
								<h2>usuarios ativos</h2>
								<ul>
									{userList.map((e) => {
										return (
											<li id={e.id}>
												<UserBlock data={e} />
											</li>
										);
									})}
								</ul>
							</div>
							<a className="more" href="/userManagement">
								Ver todos os usuários
							</a>
						</div>
					</main>
				</Container>
			</Layout>
		</div>
	);
}
